<template>
<div>

	<!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

	<template v-if="!isLoading">

		<!-- page header -->
		<page-heading :show="true" :pageTitle="isNewPage ? 'HEADER-CATALOG-NEW_PAGE_ELEMENT' : 'HEADER-CATALOG'"></page-heading>

		<div class="columns">

			<div class="col-main">

				<div class="subHeader is-clearfix">

					<div class="pageSection is-pulled-left">
						<template v-if="pageElement.catalogPage && pageElement.catalogPage.section != null">
							{{ pageElement.catalogPage.section.name }} ({{ pageElement.catalogPage.section.topicName }})
						</template>
					</div>

				</div>


				<!-- CONTENT -->
				<div class="section" :class="'status-' + pageElement.status.name">

					<div class="columns">

						<div class="column"></div>

						<div class="column is-5">

							<!-- :contentElement="pageElement.contentElement" -->
							<page-content-element ref="contentElement" :pageElement="pageElement" :productId="pageElement.contentElement.contentElementData[0].product" @save="submitForm()" @productData="productData"></page-content-element>

							<!-- <template v-if="userRole != 'Redaktion'"> -->

								<div class="control">

									<div class="control-label">
										<label-name labelKey="PAGE_ELEMENT-SELECT_BOX-PAGE_ELEMENT_STATUS"></label-name>
									</div>

									<div class="control">

										<status-dropdown :data.sync="pageElement.status" type="pageElementStatus" label="SELECT_BOX-FILTER_SITE_CATALOG_PAGE_ELEMENT_STATUS-"></status-dropdown>

										<!--
										<template v-if="$store.getters.getUser.username != 'test'">
										</template>

										<template v-else>
											<span class="select is-medium">
												<select v-model="pageElement.status" :class="[pageElement.status != null ? pageElement.status.name : '', 'statusSelector']">>
													<option v-for="status in catalogPageElementStatus" :value="status" :class="status.name">{{ $t('SELECT_BOX-CATALOG_PAGE_ELEMENT_STATUS-'+status.name) }}</option>
												</select>
											</span>
										</template>
										-->

									</div>

								</div>

							<!-- </template> -->

						</div>

						<div class="column"></div>

					</div>


				</div>


				<template v-if="product==null">

					<!-- placement COMMENTS -->
					<comments :threadID.sync="pageElement.thread" :api="'catalogPageElement/'+pageElement.id" :smallView="false"></comments>

				</template>


				<template v-else>

					<tabs type="boxed" size="normal" style="margin-top: 25px !important">

						<!-- placement comments -->
						<tab-item label="Placement Kommentare">

							<comments :threadID.sync="pageElement.thread" :api="'catalogPageElement/'+pageElement.id" :showHeader=false :key="pageElement.id"></comments>

						</tab-item>

						<!-- product comments -->
						<tab-item label="Produkt Kommentare">

							<comments v-if="product != null" :threadID.sync="product.thread" :api="'product/'+product.id" :showHeader=false labelPrefix="PAGE_ELEMENT-PRODUCT" :key="product.thread"></comments>

						</tab-item>

					</tabs>


				</template>


				<!-- CHANGE LOG -->
				<div id="logChanges" class="section">

			        <div class="title is-5">
			            <lang labelKey="HISTORY"></lang>
			        </div>

			        <log-changes :history="pageElement.changesLog"></log-changes>

				</div>


	        </div>


        <div class="col-aside">

				<affix :offset="50">

					<div class="sidebox">
						<custom-button type="blue" icon="icon-ak-speichern" name="PAGE_BUTTON-SAVE" :loading="isSaving" @click.native="submitForm"></custom-button>
					</div>

					<!-- navigate to product -->
					<template v-if="product != null">
						<!-- <router-link tag="span" class="pointer" :to="'/produkte/produkt-'+product.id">zum Produkt</router-link> -->
						<router-link tag="span" class="pointer" :to="{ name: 'product', params: { id: product.id }}">zum Produkt</router-link>
					</template>

					<div class="sidebox" v-if="userRole != 'Redaktion'">

						<div class="heading">Preview</div>

						<vue-dropzone
							ref="vueDropzonePageElement"
							url= "fileProcessing/upload?preset=catalogPageElement"
							:thumbnailWidth = "145"
							:thumbnailHeight = "67"
							:maxFiles = "1"
							:clickable="true"
							acceptedFiles = ".pdf"
							:dictDefaultMessage = "`<i class='fa fa-cloud-upload'></i>` + $t('CATALOG_CONTENT_PAGE-PREVIEW_UPLOAD')"
							v-on:vdropzone-mounted="dzPageElementInit"
							v-on:vdropzone-success="dzPageElementSuccess"
							v-on:vdropzone-removed-file="dzPageElementRemoveFile"
							dzClass="dzSingle">
						</vue-dropzone>

					</div>

					<div class="sidebox" v-if="pageElement.preview != null">
						<a :href="downloadURL" download>
							<button class="button">
								<span class="icon is-small">
									<i class="icon-ak-download"></i>
								</span>
								{{ $t("BTN-CATALOG_PAGES-DOWNLOAD_PDF")}}
							</button>
						</a>
					</div>

					<div class="sidebox" v-if="userRole == 'Administrator'">

						<button :class="[{ 'is-disabled is-success': this.pageElement.syncedAt != null }, 'button autoHeight']" @click="acceptData">

							<div>

								<template v-if="pageElement.syncedAt == null">
									{{ $t("BTN-CATALOG_PAGES-DATA_ACCEPT")}}
								</template>

								<template v-else>
									{{ $t("BTN-CATALOG_PAGES-DATA_ACCEPTED")}}
									<small>{{ formatDate(pageElement.syncedAt, 'test') }}</small>
								</template>

							</div>

						</button>



					</div>



					<template v-if="pageElement.contentElement.type.name == 'RECIPE'">

						<div class="sidebox" v-if="userRole == 'Administrator'">

							<div class="heading">Online Katalog</div>
							<crop-image :uploadPreset='catalogPageElement' :page="pageElement" @save="formSubmit"></crop-image>
							<!--
								{{ pageElement.onlineCatalogImage }}<br />
								{{ pageElement.onlineCatalogTeaser }}<br />
								{{ pageElement.onlineCatalogHeader }}
							-->
						</div>

					</template>

				</affix>


	        </div>

	    </div>

	</template>

</div>

</template>



<script>
import pageContentElement from './incl-catalogPageElementContentElement';
import comments from '../utils/incl-comments';
// import logChanges from '../utils/logChanges';
import logChanges from '../utils/incl-logChanges';
import statusDropdown from '../utils/incl-statusDropdown';
import vue2Dropzone from '../utils/dropzoneWrapper'
import cropImage from '../utils/cropImage';

export default {

	name: 'catalogPageElement',

	components: {
		comments,
		logChanges,
		pageContentElement,
		vueDropzone: vue2Dropzone,
		statusDropdown,
		cropImage
	},

	data() {

		return {
			pageElement: {},
			currentPage: null,
			productId: null,
			product: null,
			isNewPage: false,
			isLoading: true,
			isSaving: false,
        }

    },

	computed: {

		contentElementDataTypes() {
			return this.$store.getters.getTermsByTaxonomy('CONTENT_ELEMENT_DATA_TYPES');
		},

		contentElementTypes() {
			return this.$store.getters.getTermsByTaxonomy('CONTENT_ELEMENT_TYPES');
		},

		catalogPageElementStatus() {
            return this.$store.getters.getTermsByTaxonomy('CATALOG_PAGE_ELEMENT_STATUS');
        },

		downloadURL() {
			var asset = this.$config.assets +this.pageElement.preview.path + '/' + this.pageElement.preview.filename;
			return asset.substr(0, asset.lastIndexOf(".")) + ".pdf";
		},

	},

	created() {

		this.isLoading=true;

		// fetch the PAGE IDs from router
		if(this.$route.params.id && Number.isInteger(parseInt(this.$route.params.id) ) )
		{
			this.currentPage = this.$route.params.id;
			this.fetchData(this.$route.params.id);
		}
		else
		{
			this.isNewPage = true;
			this.isLoading = false;
		}

	},


    mounted() {


    },


    methods: {

		productData(value) {

			this.product = value;

		},

		acceptData() {

			var d = new Date();
			this.pageElement.syncedAt= d.toJSON();

			// copy our pageElement obj in order to change the "syncedAt" time by adding 2hours (timezone)
			var pageElementCopy = JSON.parse(JSON.stringify(this.pageElement));
			d.setHours(d.getHours() + 2);
			pageElementCopy.syncedAt = d.toJSON();

			this.isSaving = true;
			var self = this;

			this.axios.put(this.$config.api+'catalogPageElement/'+this.pageElement.id, pageElementCopy)
				.then(function(response) {
					self.isSaving = false;
					self.$notify.success({content: self.$t('MSG-SUCCESS-DATA_SAVE')});
				}).catch(function(error) {
					self.isSaving = false;
					self.$notify.open({content: self.$t('MSG-ERROR-DATA_SAVE') + ': ' + error.message, type: 'danger'});
					console.log(error);
				});

		},


		// dropzone pageElement handler
		// -----------------------------------------------------------------------

		dzPageElementInit() {

			if(this.pageElement.preview != null) {

				// set the url
				var url = this.$config.assets + this.pageElement.preview.path + '/thumb/' + this.pageElement.preview.filename;

				// change the extension from *.pdf to *.jpg
	        	url = url.substr(0, url.lastIndexOf(".")) + ".jpg";

				var mockFile = {
					id: 'previewImage',
					name: this.pageElement.preview.filename,
					type: "image/jpg",
					size: 123
				}

				// add mockFile to our dropzone
				this.$refs.vueDropzonePageElement.$children[0].manuallyAddFile(mockFile, url);

			}

		},

		dzPageElementSuccess(file) {

			var result = JSON.parse(file.xhr.response);

			this.pageElement.preview = {
				filename: result.fileName,
				path: result.dir,
				uploadFilename: file.name
			}

			// remove all files from dropzone
			this.$refs.vueDropzonePageElement.$children[0].removeAllFiles();

			// call dzPageElementInit() to add the recently uploaded PDF to our dropzone
			this.dzPageElementInit();

		},

		dzPageElementRemoveFile(file, error, xhr) {

			if(file.id == 'previewImage') {
				this.pageElement.preview = null;
			}

			// save
			this.submitForm();

		},

		submitForm() {

			// delete this.pageElement.changesLog;
			this.isSaving = true;
			var self = this;

			this.axios.put(this.$config.api+'contentElementData', this.pageElement.contentElement.contentElementData)
				.then(function(response) {
					self.isSaving = false;
					self.$notify.success({content: self.$t('MSG-SUCCESS-DATA_SAVE')});
					self.submitFormStatus();
				}).catch(function(error) {
					self.isSaving = false;
					self.$notify.open({content: self.$t('MSG-ERROR-DATA_SAVE') + ': ' + error.message, type: 'danger'});
					console.log(error);
				});

		},

		submitFormStatus() {

			this.axios.put(this.$config.api+'catalogPageElement/'+this.pageElement.id, this.pageElement)
				.then(function(response) {

				}).catch(function(error) {
					console.log(error);
				});

		},

		fetchData(pageElementID) {

			if(isNaN(pageElementID)) {
				return false;
			}

			this.isLoading = true;

            var self = this;
			var url = this.$config.api + 'catalogPageElement/'+pageElementID+'?include=catalogPageElement.onlineCatalogImage,catalogPageElement.onlineCatalogTeaser,catalogPageElement.onlineCatalogHeader,catalogPageElement.status,catalogPage.section,catalogPageElement.preview,contentElement.type,catalogPageElement.catalogPageLayout,contentElementData.type,catalogPageElement.catalogPage,catalogPageElement.contentElement,contentElement.contentElementData,contentElementData.assets,contentElementDataAsset.asset&loadChangesLog=1';

			// make the request
			this.axios.get(url)

				.then(function(response) {

					for(var i = 0; i < response.data.contentElement.type.data.length; i++)
					{

						if(typeof response.data.contentElement.contentElementData[i] == 'undefined')
						{
							response.data.contentElement.contentElementData[i] = {
								name: response.data.contentElement.type.data[i].label,
								value: "",
								product: null,
								contentElement: { id: response.data.contentElement.id },
								sortorder: 0,
								type: self.getElementDataType(response.data.contentElement.type.data[i].contentElementDataType)
							}
						}
					}

					self.pageElement = response.data;
					self.isLoading = false;

				}).catch(function(error) {

					self.isLoading = false;
					// show error notify
					self.$notify.open({content: error.message, type: 'danger'});

				});

				return;

		},

		getElementDataType(typeId) {

			for (var property in this.contentElementDataTypes)
			{
			    if (this.contentElementDataTypes.hasOwnProperty(property))
				{
					if(this.contentElementDataTypes[property].id == typeId) {
						return this.contentElementDataTypes[property];
					}
			    }
			}

		}

    }

}

</script>


<style lang="scss" scoped>

    @import '../../assets/css/variables.scss';

	.status-CREATED {
        border-top: 10px solid $statusCreated;
    }
    .status-READY {
        border-top: 10px solid $statusReady;
    }
    .status-EDITED {
        border-top: 10px solid $statusEdited;
    }
    .status-LAYOUTED {
        border-top: 10px solid $statusLayouted;
    }
    .status-REVISED {
        border-top: 10px solid $statusRevised;
    }
    .status-APPROVED {
        border-top: 10px solid $statusApproved;
    }
    .status-PRINT_APPROVED {
        border-top: 10px solid $statusPrintApproved;
    }
	.status-REVIEW {
        border-top: 10px solid $statusReview;
    }

</style>


<style scoped>
	.section .is-5 {
		min-width: 500px;
	}
</style>


<style>
	#commentsContainer {
	    margin: 30px 0;
	}
	#logChanges .title,
	#commentsContainer .title {
	    margin: 0 0 25px 0 !important;
	}
	#commentsContainer .avatar {
	    max-width: 80px;
	}
	#commentsContainer .avatar img {
	    width: 100%;
	    opacity: .7;
	}

	.subHeader {
		margin: 0 0 25px 0;
	}
	.subHeader .pageSection {
		font-size: 24px;
		color: #999;
		font-weight: 300;
	}
</style>
